import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Generation {
  id: string;
  prompt: string;
  model: string;
  mode: string;
  image_url: string;
  width: number;
  height: number;
  strength: number | null;
  source_image_url: string | null;
  created_at: string;
}

export const useGenerations = (limit = 20) => {
  return useQuery({
    queryKey: ["generations", limit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("generations")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(limit);

      if (error) throw error;
      return data as Generation[];
    },
  });
};
